export class NzorNameCriteria {
  nameCriteria: string;
  nameClassList: string[];
  pageNumber = 1;
  pageSize = 12;
}
